<script setup lang="ts">
import type { ProductPercentageCostsPrice } from "~/types/ProductCosts";

type Props = ProductPercentageCostsPrice & {
  isFinalPrice?: boolean;
};

defineProps<Props>();
</script>

<template>
  <li
    v-if="costs?.currency"
    class="my-2 w-full"
    data-test="product-costs-sales-tax"
  >
    <div class="flex items-center justify-between">
      <p class="flex gap-1">
        {{ $t("product.costs.salesTax") }}
        <span
          v-if="percentage && percentage > 0"
          data-test="product-costs-sales-tax-percentage"
        >
          ({{ percentage }}%)
        </span>
        <BaseTooltip class="ml-1">
          <p>{{ $t("product.costs.salesTaxInfo") }}</p>
        </BaseTooltip>
      </p>

      <Transition
        v-if="isFinalPrice"
        name="fade"
        mode="out-in"
      >
        <BaseCurrency
          :key="costs.price"
          data-test="product-costs-sales-tax-price"
          :show-decimals="true"
          :value="costs.price"
          :iso="costs.currency"
        />
      </Transition>
      <p
        v-else
        class="text-platform-text-3"
      >
        {{ $t("product.costs.calculationCheckout") }}
      </p>
    </div>
  </li>
</template>

<style lang="postcss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
